"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utmReducer = exports.setUtmState = void 0;
var ts_action_1 = require("ts-action");
/* Redux */
exports.setUtmState = ts_action_1.action('setUtmState', ts_action_1.payload());
var initialState = {
    utmCampaign: '',
    utmContent: '',
    utmMedium: '',
    utmSource: '',
    utmTerm: ''
};
exports.utmReducer = ts_action_1.reducer(initialState, ts_action_1.on(exports.setUtmState, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), payload));
}));
//# sourceMappingURL=utm.js.map